<template>
  <div class="blog-home blog-page-container" :style="backgroundStyle">
    <!-- 背景图层 -->
    <div class="background-layer" :style="backgroundLayerStyle"></div>
    
    <!-- 移除原有的移动端导航切换按钮 -->
    
    <div class="mobile-nav-menu" :class="{ active: mobileNavActive }">
      <div class="mobile-nav-header">
        <div class="mobile-blogger-info">
          <div class="mobile-blogger-avatar">
            <img src="@/assets/images/blog/head.png" alt="博主头像" />
          </div>
          <div class="mobile-blogger-details">
            <h3 class="mobile-blogger-name">{{ bloggerInfo.name }}</h3>
            <p class="mobile-blogger-bio">{{ bloggerInfo.bio }}</p>
          </div>
        </div>
      </div>
      
      <div class="mobile-nav-search">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索文章标题或内容"
          prefix-icon="el-icon-search"
          @keyup.enter.native="handleSearch"
          clearable
          size="small"
        ></el-input>
      </div>
      
      <div class="mobile-nav-tags">
        <div class="mobile-nav-section-title">标签云</div>
        <div class="mobile-tag-list">
          <el-tag 
            :class="{ active: selectedTag === '' }"
            @click="handleFilterTag(''); closeMobileNav()"
            size="mini"
            class="mobile-tag-item"
          >
            全部
          </el-tag>
          <el-tag 
            v-for="tag in filteredTags" 
            :key="'tag-' + tag"
            :class="{ active: selectedTag === tag }"
            @click="handleFilterTag(tag); closeMobileNav()"
            size="mini"
            class="mobile-tag-item"
          >
            {{ tag }}
          </el-tag>
        </div>
      </div>
    </div>
    
    <div class="mobile-nav-backdrop" :class="{ active: mobileNavActive }" @click="closeMobileNav"></div>
    
    <!-- 博客头部 -->
    <div class="blog-header" :style="contentCardStyle">
      <div class="blog-header-content">
        <div class="blog-info">
          <h1 class="blog-title">
            <span class="crown-icon">&#128081;</span>
            ziyanlin2013's Blog
          </h1>
          <div class="blog-subtitle">随随便便.点点滴滴</div>
        </div>
        <!-- 右侧按钮组容器，仅PC端显示 -->
        <div class="header-right-buttons" v-if="!isMobile">
          <div class="bg-settings-container">
            <background-settings @background-updated="handleBgSettingsUpdated" />
          </div>
          <!-- 视图切换按钮 -->
          <el-tooltip content="切换视图" placement="top" :enterable="false">
            <el-button
              class="icon-btn view-toggle-btn"
              type="primary"
              size="small"
              circle
              @click="toggleViewMode"
            >
              <i :class="viewMode === 'card' ? 'el-icon-s-grid' : 'el-icon-s-unfold'"></i>
            </el-button>
          </el-tooltip>
        </div>
      </div>
        
      <!-- 导航按钮区域 -->
      <div class="blog-nav">
        <div class="nav-buttons">
        <el-button 
            :type="selectedType === '' ? 'primary' : 'text'"
            size="small" 
            class="nav-button"
            :class="{'selected-nav-button': selectedType === ''}"
            :style="selectedType === '' ? { '--btn-bg-color': '#409EFF' } : {}"
            @click="handleFilterType('')"
        >
            全部
        </el-button>
          <el-button 
            v-for="type in articleTypes" 
            :key="type.value"
            :type="selectedType === type.value ? 'primary' : 'text'"
            :style="selectedType === type.value ? { 
              backgroundColor: getArticleTypeStyle(type.value), 
              borderColor: getArticleTypeStyle(type.value),
              '--btn-bg-color': getArticleTypeStyle(type.value)
            } : {}"
            size="small"
            class="nav-button"
            :class="{'selected-nav-button': selectedType === type.value}"
            @click="handleFilterType(type.value)"
          >
            {{ type.label }}
          </el-button>
        </div>
      </div>
    </div>
    
    <!-- 移动端分类过滤栏 -->
    <div class="mobile-type-filter" v-if="isMobile" :style="contentCardStyle">
      <div class="mobile-type-filter-scroll">
        <div 
          class="mobile-type-item" 
          :class="{ active: selectedType === '' }"
          @click="handleFilterType('')"
        >
          全部
        </div>
        <div 
          v-for="type in articleTypes" 
          :key="'mobile-' + type.value"
          class="mobile-type-item"
          :class="{ active: selectedType === type.value }"
          :style="selectedType === type.value ? { 
            backgroundColor: getArticleTypeStyle(type.value), 
            borderColor: getArticleTypeStyle(type.value)
          } : {}"
          @click="handleFilterType(type.value)"
        >
          {{ type.label }}
        </div>
      </div>
    </div>
    
    <!-- 内容区域 -->
    <div class="blog-content">
      <!-- 文章卡片瀑布流区域 -->
      <div class="article-cards" v-loading="loading">
        <!-- 卡片视图空状态 -->
        <div v-if="articles.length === 0 && !loading && viewMode === 'card'" class="article-card-container">
          <div class="waterfall">
            <div class="no-data" :style="contentCardStyle">
              <div class="no-data-content">
          <i class="el-icon-document"></i>
                <span class="no-data-title">暂无文章</span>
                <p class="no-data-tips">
                  没有找到符合条件的文章，请尝试调整筛选条件
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 卡片视图 -->
        <div class="article-card-container" v-show="viewMode === 'card'">
          <div class="waterfall">
            <!-- 修改 el-tooltip，添加移动设备检测条件，在移动设备上不显示tooltip -->
            <el-tooltip
              v-for="article in articles"
              :key="article.article_code"
              :content="article.article_name"
              placement="top"
              :enterable="false"
              effect="dark"
              :disabled="isMobile"
            >
              <div
                class="article-card"
                :style="contentCardStyle"
                @click="handleViewArticle(article)"
                :class="{ [`article-card-${getArticleTypeClass(article.article_type)}`]: true }"
              >
                <!-- 文章类型装饰 -->
                <div class="article-type-decoration"></div>

                <!-- 置顶+加密标签容器 -->
                <div class="top-badges">
                  <div v-if="article.is_top" class="top-pill" aria-label="置顶">
                    <i class="el-icon-top"></i>
                  </div>
                  <div v-if="article.has_password" class="encrypted-pill" aria-label="加密">
                    <i class="el-icon-lock"></i>
                  </div>
                </div>

                <!-- 阅读数气泡 -->
                <div class="read-count-bubble">
                  <i class="el-icon-view"></i>
                  <span>{{ article.read_count || 0 }}</span>
                </div>

                <!-- 文章摘要封面（装饰性色条） -->
                <div class="article-cover" :class="'article-cover-' + getArticleTypeClass(article.article_type)"></div>

                <!-- 文章信息 -->
                <div class="article-info">
                  <div class="article-content">
                    <!-- 文章标题行 -->
                    <div class="title-wrap">
                      <h3 class="article-title">{{ article.article_name }}</h3>
                    </div>
                    <!-- 类型+日期行 -->
                    <div class="article-meta">
                      <el-tag
                        :color="getArticleTypeStyle(article.article_type)"
                        effect="dark"
                        size="mini"
                        class="article-type"
                      >
                        {{ article.article_type }}
                      </el-tag>
                      <div class="article-stats">
                        <span class="article-time">
                          <i class="el-icon-date"></i>
                          {{ formatDate(article.create_time) }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="article-divider"></div>

                  <div class="article-footer">
                    <div class="article-tags" v-if="article.article_tag && article.article_tag.split(',').filter(tag => tag.trim()).length > 0">
                    <el-tag
                        v-for="tag in article.article_tag.split(',').filter(tag => tag.trim())"
                      :key="tag"
                      size="mini"
                      class="article-tag"
                    >
                      {{ tag }}
                    </el-tag>
                    </div>
                    <div class="article-tags-placeholder" v-else></div>
                    <div class="read-more">
                      <span>阅读全文</span>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </el-tooltip>
          </div>
        </div>

        <!-- 列表视图 -->
        <div class="article-list-container" v-show="viewMode === 'list'" v-loading="loading">
          <!-- 暂无文章 -->
          <div v-if="articles.length === 0 && !loading && viewMode === 'list'" class="article-list-empty" :style="contentCardStyle">
            <div class="no-data-content">
              <i class="el-icon-document"></i>
              <span class="no-data-title">暂无文章</span>
              <p class="no-data-tips">
                没有找到符合条件的文章，请尝试调整筛选条件
              </p>
            </div>
          </div>

          <!-- 列表项 -->
          <div
            v-for="article in articles"
            :key="article.article_code"
            class="article-list-item"
            :style="contentCardStyle"
            @click="handleViewArticle(article)"
          >
            <!-- 左侧类型色块 -->
            <div
              class="list-item-type"
              :style="{ backgroundColor: getArticleTypeStyle(article.article_type) }"
            >
              <span class="type-text" :class="{ 'is-english': isEnglishType(article.article_type) }">{{ article.article_type }}</span>
            </div>

            <!-- 右侧内容区 -->
            <div class="list-item-content">
              <!-- 第一行：标题 + 阅读数 -->
              <div class="list-item-row1">
                <h3 class="list-item-title">{{ article.article_name }}</h3>
                <div class="list-item-views">
                  <i class="el-icon-view"></i>
                  <span>{{ article.read_count || 0 }}</span>
                </div>
              </div>

              <!-- 第二行：置顶/加密 + 标签 + 时间 -->
              <div class="list-item-row2">
                <div class="list-item-left">
                  <span v-if="article.is_top" class="list-item-badge top-badge" title="置顶">
                    <i class="el-icon-top"></i>
                  </span>
                  <span v-if="article.has_password" class="list-item-badge lock-badge" title="加密">
                    <i class="el-icon-lock"></i>
                  </span>
                  <div class="list-item-tags" v-if="article.article_tag && article.article_tag.split(',').filter(tag => tag.trim()).length > 0">
                    <el-tag
                      v-for="tag in article.article_tag.split(',').filter(tag => tag.trim())"
                      :key="tag"
                      size="mini"
                      class="list-tag"
                    >
                      {{ tag }}
                    </el-tag>
                  </div>
                </div>
                <div class="list-item-right">
                  <span class="list-item-date">{{ formatDate(article.create_time) }}</span>
                </div>
              </div>
            </div>
          </div>

          </div>
        <!-- 加载更多 / 到底提示 -->
        <div v-if="hasMore && !loading && articles.length > 0" class="load-more">
          <el-button type="text" @click="loadMore">加载更多</el-button>
        </div>
        <div v-if="loading && articles.length > 0" class="loading-more">
          <i class="el-icon-loading"></i>
          <span>加载中...</span>
        </div>
        <div v-if="!hasMore && articles.length > 0" class="no-more">
          <span>------已经到底啦------</span>
          <div class="copyright-info">
            <span class="pc-copyright">Copyright © 2024 OIer之路 All rights reserved. ｜ 闽ICP备2025095302号-1</span>
            <span class="mobile-copyright">Copyright © 2024 OIer之路 All rights reserved.<br>闽ICP备2025095302号-1</span>
          </div>
        </div>
      </div>
      
      <!-- 右侧过滤区域 -->
      <div class="filter-panel">
        <!-- 博主信息卡片 -->
        <el-card class="blogger-card" :style="contentCardStyle">
          <div class="blogger-info">
            <div class="blogger-avatar">
              <img src="@/assets/images/blog/head.png" alt="博主头像" />
            </div>
            <div class="blogger-details">
              <h3 class="blogger-name">{{ bloggerInfo.name }}</h3>
              <p class="blogger-bio">{{ bloggerInfo.bio }}</p>
              
              <div class="blogger-divider"></div>
              
              <div class="blogger-stats">
                <div class="stats-item">
                  <div class="stats-number">{{ formatStatNumber(bloggerInfo.articleCount) }}</div>
                  <div class="stats-label">Articles</div>
                </div>
                <div class="stats-item">
                  <div class="stats-number">{{ formatStatNumber(allTags.length) }}</div>
                  <div class="stats-label">Tags</div>
                </div>
                <div class="stats-item">
                  <div class="stats-number">{{ formatStatNumber(bloggerInfo.totalReads) }}</div>
                  <div class="stats-label">Reads</div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
        
        <el-card class="filter-card" :style="contentCardStyle">
          <div class="filter-header">
            <span class="filter-title">搜索</span>
          </div>
          <div class="filter-content">
            <el-input
              v-model="searchKeyword"
              placeholder="搜索文章标题或内容"
              prefix-icon="el-icon-search"
              @keyup.enter.native="handleSearch"
              clearable
            ></el-input>
          </div>
        </el-card>
        
        <!-- 移除文章分类卡片，因为已经移到顶部导航 -->
        
        <el-card class="filter-card" :style="contentCardStyle">
          <div class="filter-header">
            <span class="filter-title">标签云</span>
          </div>
          <div class="filter-content">
            <el-input
              v-model="tagSearchKeyword"
              placeholder="搜索标签"
              prefix-icon="el-icon-search"
              clearable
              size="small"
              class="tag-search-input"
              @input="filterTags"
            ></el-input>
            <div class="filter-tags">
              <el-tag 
                class="filter-tag-item"
                :class="{ active: selectedTag === '' }"
                @click="handleFilterTag('')"
                size="mini"
              >
                全部
              </el-tag>
              <el-tag 
                v-for="tag in filteredTags" 
                :key="tag"
                :effect="selectedTag === tag ? 'dark' : 'plain'"
                class="filter-tag-item"
                @click="handleFilterTag(tag)"
                size="mini"
              >
                {{ tag }}
              </el-tag>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    
    <!-- 移动端按钮组，固定在右下角垂直排列 -->
    <div v-if="isMobile" class="mobile-action-buttons">
      <!-- 菜单按钮 -->
      <div class="mobile-btn-wrapper">
        <el-button
          class="mobile-icon-btn"
          @click="toggleMobileNav"
        >
          <i class="el-icon-menu"></i>
        </el-button>
      </div>

      <!-- 视图切换按钮 -->
      <div class="mobile-btn-wrapper">
        <el-tooltip content="切换视图" placement="top" :enterable="false">
          <el-button
            class="mobile-icon-btn"
            @click="toggleViewMode"
          >
            <i :class="viewMode === 'card' ? 'el-icon-s-grid' : 'el-icon-s-unfold'"></i>
          </el-button>
        </el-tooltip>
      </div>

      <!-- 背景设置按钮 -->
      <div class="mobile-btn-wrapper">
        <background-settings @background-updated="handleBgSettingsUpdated" />
      </div>
    </div>
  </div>
</template>

<script>
import { getBlogArticles } from '@/api/article'
import BackgroundSettings from '@/components/BackgroundSettings.vue'
import request from '@/utils/request'

export default {
  name: 'BlogHome',
  components: {
    BackgroundSettings
  },
  data() {
    return {
      loading: false,
      articles: [],
      page: 1,
      pageSize: 12,
      total: 0,
      hasMore: true,
      searchKeyword: '',
      selectedType: '',
      selectedTag: '',
      allTags: [],
      filteredTags: [],
      tagSearchKeyword: '',
      bloggerInfo: {
        name: 'ziyanlin2013',
        bio: '一只小蒟蒻',
        articleCount: 0,
        totalReads: 0,
      },

      // 背景相关设置
      contentCardStyle: { backgroundColor: 'rgba(255, 255, 255, 0.8)' },
      backgroundLayerStyle: {},
      backgroundStyle: { backgroundColor: '#f0f2f5' },

      // 文章类型选项
      articleTypes: [
        { value: 'OI', label: 'OI' },
        { value: '题解', label: '题解' },
        { value: '游记', label: '游记' },
        { value: '生活', label: '生活' },
        { value: '学习', label: '学习' },
        { value: '科技', label: '科技' },
        { value: '情感', label: '情感' },
        { value: '游戏', label: '游戏' },
        { value: '随笔', label: '随笔' },
        { value: '其他', label: '其他' }
      ],

      // 移动端导航相关
      isMobile: false,
      mobileNavActive: false,
      viewMode: 'card',
      hasScrolled: false,
    }
  },
  created() {
    // 从 LocalStorage 读取视图模式
    const savedViewMode = localStorage.getItem('blogViewMode')
    if (savedViewMode === 'list' || savedViewMode === 'card') {
      this.viewMode = savedViewMode
    }
    // 获取文章列表
    this.getArticles()
    // 获取所有标签
    this.getAllTags()
    // 获取博客统计信息
    this.getBlogStats()
    // 检测设备类型
    this.checkDeviceType()
  },
  mounted() {
    this.hideGlobalMobileMenu()
    this.$nextTick(() => {
      const articleContainer = document.querySelector('.article-cards')
      const filterPanel = document.querySelector('.filter-panel')
      const filterTags = document.querySelector('.filter-tags')

      if (articleContainer) {
        articleContainer.addEventListener('scroll', this.handleScroll)
        this.checkInitialLoad()
        articleContainer.addEventListener('wheel', function(event) {
          const scrollTop = articleContainer.scrollTop
          const scrollHeight = articleContainer.scrollHeight
          const clientHeight = articleContainer.clientHeight

          if ((scrollTop <= 0 && event.deltaY < 0) ||
              (scrollTop + clientHeight >= scrollHeight && event.deltaY > 0)) {
            event.preventDefault()
            return false
          }
        }, { passive: false })
      }

      document.body.style.overflow = 'hidden'
      document.addEventListener('wheel', this.preventScrollOutsideContent, { passive: false })

      if (filterPanel) {
        filterPanel.addEventListener('wheel', function(event) {
          const scrollTop = filterPanel.scrollTop
          const scrollHeight = filterPanel.scrollHeight
          const clientHeight = filterPanel.clientHeight

          if ((scrollTop <= 0 && event.deltaY < 0) ||
              (scrollTop + clientHeight >= scrollHeight && event.deltaY > 0)) {
            event.preventDefault()
            return false
          }
        }, { passive: false })
      }

      if (filterTags) {
        filterTags.addEventListener('wheel', function(event) {
          event.stopPropagation()

          const scrollTop = filterTags.scrollTop
          const scrollHeight = filterTags.scrollHeight
          const clientHeight = filterTags.clientHeight

          if ((scrollTop <= 0 && event.deltaY < 0) ||
              (scrollTop + clientHeight >= scrollHeight && event.deltaY > 0)) {
            event.preventDefault()
          } else {
            event.preventDefault()
            filterTags.scrollTop += event.deltaY * 0.5
          }
        }, { passive: false })

        filterTags.style.webkitOverflowScrolling = 'touch'
        filterTags.style.touchAction = 'pan-y'
      }

      window.addEventListener('resize', this.handleResize)
      this.checkDeviceType()
    })
  },
  beforeDestroy() {
    const articleContainer = document.querySelector('.article-cards')
    const filterPanel = document.querySelector('.filter-panel')
    const filterTags = document.querySelector('.filter-tags')

    if (articleContainer) {
      articleContainer.removeEventListener('scroll', this.handleScroll)
      articleContainer.removeEventListener('wheel', function() {})
    }

    document.removeEventListener('wheel', this.preventScrollOutsideContent)

    if (filterPanel) {
      filterPanel.removeEventListener('wheel', function() {})
    }

    if (filterTags) {
      filterTags.removeEventListener('wheel', function() {})
    }

    window.removeEventListener('resize', this.handleResize)
    document.body.style.overflow = ''
    this.restoreGlobalMobileMenu()
  },
  methods: {
    restoreGlobalMobileMenu() {
      const globalMobileMenuBtn = document.querySelector('#app > .mobile-menu-btn')
      if (globalMobileMenuBtn) {
        if (window.innerWidth <= 768) {
          globalMobileMenuBtn.style.display = 'flex'
        }
      }
    },

    hideGlobalMobileMenu() {
      const globalMobileMenuBtn = document.querySelector('#app > .mobile-menu-btn')
      if (globalMobileMenuBtn) {
        globalMobileMenuBtn.style.display = 'none'
      }
    },

    handleBgSettingsUpdated(settings) {
      this.contentCardStyle = settings.contentCardStyle
      this.backgroundLayerStyle = settings.backgroundLayerStyle
      this.backgroundStyle = settings.backgroundStyle
    },

    getArticleTypeStyle(type) {
      const styleMap = {
        'OI': '#409EFF',
        '题解': '#67C23A',
        '游记': '#E6A23C',
        '生活': '#F56C6C',
        '学习': '#8E44AD',
        '科技': '#16A085',
        '情感': '#D35400',
        '游戏': '#2980B9',
        '随笔': '#27AE60',
        '其他': '#C0392B'
      }
      return styleMap[type] || ''
    },

    getArticleTypeClass(type) {
      const classMap = {
        'OI': 'blue',
        '题解': 'green',
        '游记': 'orange',
        '生活': 'red',
        '学习': 'purple',
        '科技': 'teal',
        '情感': 'brown',
        '游戏': 'navy',
        '随笔': 'emerald',
        '其他': 'crimson'
      }
      return classMap[type] || 'default'
    },

    getArticleSummary(content) {
      if (!content) return '暂无内容'

      const plainText = content
        .replace(/!\[.*?\]\(.*?\)/g, '')
        .replace(/\[.*?\]\(.*?\)/g, '$1')
        .replace(/#{1,6}\s+/g, '')
        .replace(/(\*\*|__)(.*?)(\*\*|__)/g, '$2')
        .replace(/(\*|_)(.*?)(\*|_)/g, '$2')
        .replace(/`{1,3}[\s\S]*?`{1,3}/g, '')
        .replace(/~~(.*?)~~/g, '$1')
        .replace(/\$\$([\s\S]*?)\$\$/g, '')
        .replace(/\$(.*?)\$/g, '')
        .replace(/\n+/g, ' ')
        .trim()

      const maxLength = 100

      if (plainText.length <= maxLength) {
        return plainText
      }

      const breakPoints = ['. ', '。', '! ', '！', '? ', '？', '; ', '；', '，', ', ']
      let bestBreakPoint = maxLength

      for (const point of breakPoints) {
        const index = plainText.lastIndexOf(point, maxLength - 1)
        if (index > maxLength * 0.6) {
          bestBreakPoint = index + point.length
          break
        }
      }

      if (bestBreakPoint === maxLength) {
        const lastSpace = plainText.lastIndexOf(' ', maxLength - 1)
        if (lastSpace > maxLength * 0.8) {
          bestBreakPoint = lastSpace
        }
      }

      return plainText.substring(0, bestBreakPoint) + (bestBreakPoint < plainText.length ? '...' : '')
    },

    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    },

    async getArticles(isLoadMore = false) {
      if (this.loading) return

      this.loading = true
      try {
        const params = {
          page: this.page,
          size: this.pageSize,
          keyword: this.searchKeyword,
          article_type: this.selectedType,
          article_tag: this.selectedTag,
          exact_tag_match: this.selectedTag ? true : false,
          sort_prop: 'create_time',
          sort_order: 'descending'
        }

        const response = await getBlogArticles(params)

        if (isLoadMore) {
          this.articles = [...this.articles, ...response.data.items]
        } else {
          this.articles = response.data.items
        }

        this.total = response.data.total
        this.hasMore = this.articles.length < this.total

        this.extractAllTags()

        if (isLoadMore) {
          this.$nextTick(() => {
            this.checkInitialLoad()
          })
        }
      } catch (error) {
        console.error('获取文章列表失败：', error)
        this.$message.error('获取文章列表失败')
      }
      this.loading = false
      if (!isLoadMore) {
        this.checkInitialLoad()
      }
    },

    loadMore() {
      if (!this.hasMore || this.loading) return
      this.page++
      this.getArticles(true)
    },

    handleScroll() {
      if (!this.hasScrolled) {
        this.hasScrolled = true
      }

      if (this.loading || !this.hasMore) return

      const articleContainer = document.querySelector('.article-cards')
      if (!articleContainer) return

      const scrollHeight = articleContainer.scrollHeight
      const scrollTop = articleContainer.scrollTop
      const clientHeight = articleContainer.clientHeight

      if (scrollHeight - scrollTop - clientHeight < 100) {
        this.loadMore()
      }
    },

    handleViewArticle(article) {
      this.$router.push(`/blog/view/${article.article_code}`)
    },

    handleSearch() {
      this.page = 1
      this.hasScrolled = false
      this.getArticles()
      this.closeMobileNav()
    },

    handleFilterType(type) {
      this.selectedType = type
      this.page = 1
      this.hasScrolled = false
      this.getArticles()
    },

    handleFilterTag(tag) {
      this.selectedTag = tag
      this.page = 1
      this.hasScrolled = false
      this.getArticles()
    },

    extractAllTags() {
      const tagsSet = new Set()
      this.articles.forEach(article => {
        if (article.article_tag) {
          const tags = article.article_tag.split(',')
          tags.forEach(tag => tagsSet.add(tag.trim()))
        }
      })
    },

    async getAllTags() {
      try {
        const params = {
          page: 1,
          size: 1000,
          sort_prop: 'create_time',
          sort_order: 'descending'
        }

        const response = await getBlogArticles(params)

        if (response.data && response.data.items) {
          const tagsSet = new Set()

          response.data.items.forEach(article => {
            if (article.article_tag) {
              const tags = article.article_tag.split(',')
              tags.forEach(tag => tagsSet.add(tag.trim()))
            }
          })

          this.allTags = Array.from(tagsSet).sort()
          this.filteredTags = [...this.allTags]
        }
      } catch (error) {
        console.error('获取所有标签失败：', error)
      }
    },

    filterTags() {
      if (!this.tagSearchKeyword) {
        this.filteredTags = [...this.allTags]
        return
      }

      const keyword = this.tagSearchKeyword.toLowerCase()
      this.filteredTags = this.allTags.filter(tag =>
        tag.toLowerCase().includes(keyword)
      )
    },

    async getBlogStats() {
      try {
        const params = {
          page: 1,
          size: 1,
          sort_prop: 'create_time',
          sort_order: 'descending'
        }

        const response = await getBlogArticles(params)
        if (response.data && response.data.total !== undefined) {
          this.bloggerInfo.articleCount = response.data.total
        }

        await this.calculateTotalReads()

      } catch (error) {
        console.error('获取博客统计信息失败：', error)
      }
    },

    async calculateTotalReads() {
      try {
        const params = {
          page: 1,
          size: 1000,
          sort_prop: 'create_time',
          sort_order: 'descending'
        }

        const response = await getBlogArticles(params)

        if (response.data && response.data.items) {
          let totalReads = 0
          response.data.items.forEach(article => {
            totalReads += article.read_count || 0
          })

          this.bloggerInfo.totalReads = totalReads
        }
      } catch (error) {
        console.error('计算总阅读量失败：', error)
        this.bloggerInfo.totalReads = 0
      }
    },

    checkInitialLoad() {
      this.$nextTick(() => {
        const articleContainer = document.querySelector('.article-cards')
        if (!articleContainer) return

        const scrollHeight = articleContainer.scrollHeight
        const clientHeight = articleContainer.clientHeight

        if (scrollHeight <= clientHeight && this.hasMore && !this.loading) {
          this.loadMore()
        }
      })
    },

    preventScrollOutsideContent(event) {
      const articleCards = document.querySelector('.article-cards')
      const filterPanel = document.querySelector('.filter-panel')
      const filterTags = document.querySelector('.filter-tags')

      if (articleCards && filterPanel) {
        const isInArticleCards = articleCards.contains(event.target) || articleCards === event.target
        const isInFilterPanel = filterPanel.contains(event.target) || filterPanel === event.target
        const isInFilterTags = filterTags && (filterTags.contains(event.target) || filterTags === event.target)

        if (isInFilterTags) {
          return true
        }

        if (!isInArticleCards && !isInFilterPanel) {
          event.preventDefault()
          event.stopPropagation()
          return false
        }

        if (isInFilterPanel) {
          const scrollTop = filterPanel.scrollTop
          const scrollHeight = filterPanel.scrollHeight
          const clientHeight = filterPanel.clientHeight

          if ((scrollTop <= 0 && event.deltaY < 0) ||
              (scrollTop + clientHeight >= scrollHeight && event.deltaY > 0)) {
            event.preventDefault()
            event.stopPropagation()
            return false
          }
        }

        if (isInArticleCards) {
          const scrollTop = articleCards.scrollTop
          const scrollHeight = articleCards.scrollHeight
          const clientHeight = articleCards.clientHeight

          if ((scrollTop <= 0 && event.deltaY < 0) ||
              (scrollTop + clientHeight >= scrollHeight && event.deltaY > 0)) {
            event.preventDefault()
            event.stopPropagation()
            return false
          }
        }
      }
    },

    formatStatNumber(num) {
      if (num === undefined || num === null) return '0'
      if (num < 1000) return num.toString()
      if (num < 1000000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
      }
      return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
    },

    toggleMobileNav() {
      this.mobileNavActive = !this.mobileNavActive
    },

    toggleViewMode() {
      this.viewMode = this.viewMode === 'card' ? 'list' : 'card'
      localStorage.setItem('blogViewMode', this.viewMode)
    },

    isEnglishType(type) {
      return /^[A-Za-z]+$/.test(type)
    },

    closeMobileNav() {
      this.mobileNavActive = false
    },

    showSearchDialog() {
      this.closeMobileNav()
      this.$nextTick(() => {
        const searchInput = document.querySelector('.mobile-nav-search .el-input__inner')
        if (searchInput) {
          this.mobileNavActive = true
          setTimeout(() => {
            searchInput.focus()
          }, 300)
        }
      })
    },

    checkDeviceType() {
      this.isMobile = window.innerWidth <= 768
    },

    handleResize() {
      this.checkDeviceType()
      if (!this.isMobile) {
        this.mobileNavActive = false
      }
      this.hideGlobalMobileMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
.blog-home {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden; /* 防止整体出现滚动条 */
  padding-bottom: 20px;
  
  // 添加这个类来覆盖App.vue中的全局移动端样式
  :deep(.mobile-menu-btn) {
    display: none !important; // 强制隐藏App.vue中的移动端菜单按钮
  }
  
  .background-layer {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    background-position: center;
    pointer-events: none;
    z-index: 0;
  }
  
  /* 移动端按钮组的样式 */
  .mobile-action-buttons {
    position: fixed !important; /* 确保固定定位 */
    right: 15px !important;
    bottom: 80px !important;
    display: flex !important; /* 确保显示 */
    flex-direction: column !important;
    gap: 15px !important;
    z-index: 2001 !important; /* 增加z-index确保显示在最上层 */
    
    .mobile-icon-btn {
      width: 40px !important;
      height: 40px !important;
      border-radius: 40px !important;
      background-color: rgba(255, 255, 255, 0.5) !important;
      color: #409eff !important;
      border: none !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      padding: 0 !important;
      transition: all 0.3s ease !important;
      
      i {
        font-size: 20px !important;
      }
      
      &:hover, &:focus {
        background-color: rgba(255, 255, 255, 0.8) !important;
        transform: scale(1.05) !important;
      }
      
      &:active {
        background-color: rgba(255, 255, 255, 0.9) !important;
        transform: scale(0.95) !important;
      }
    }
  }
  
  /* 统一移动端按钮包装器样式 */
  .mobile-btn-wrapper {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 40px !important;
    height: 40px !important;
  }

  /* 确保移动端背景设置按钮包装器正确显示 */
  .mobile-bg-settings-wrapper {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 40px !important;
    height: 40px !important;
    z-index: 2001 !important;
  }
  
  .blog-header {
    height: 118px; /* 从126px减少到118px，补偿副标题与横线之间间距的减少 */
    padding: 0 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    position: fixed; /* 改为固定定位 */
    top: 0; /* 固定在顶部 */
    left: 0; /* 固定在左侧 */
    right: 0; /* 固定在右侧 */
    z-index: 10; /* 提高z-index确保在其他元素上方 */
    width: 100%; /* 确保宽度为100% */
    
    .blog-header-content {
      max-width: 1200px;
      margin: 0 auto;
      height: 80px; /* 保持减少后的高度 */
      margin-bottom: 0; /* 确保没有底部边距 */
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      .blog-info {
        padding-bottom: 0;
        
        .blog-title {
          font-size: 28px;
          font-weight: bold;
          margin: 0;
          color: #303133;
          position: relative;
          
          .crown-icon {
            position: absolute;
            left: -27px;
            top: -16px;
            font-size: 32px;
            transform: rotate(-45deg);
            display: inline-block;
            z-index: 2;
          }
        }
        
        .blog-subtitle {
          font-size: 14px;
          color: #606266;
          margin-top: 5px;
        }
      }

      /* 右侧按钮组容器 */
      .header-right-buttons {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-left: auto; /* 确保靠右对齐 */
        margin-right: 20px; /* 添加右侧边距 */

        .bg-settings-container {
          display: flex;
          align-items: center;
        }

        .view-toggle-btn {
          background-color: #409eff;
          color: #ffffff;
          border-color: #409eff;
          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
          transform: translateY(0);
          transition: all 0.3s ease;

          i {
            font-size: 20px;
            margin: 0;
            line-height: 1;
          }

          &:hover {
            background-color: #66b1ff;
            color: #ffffff;
            border-color: #66b1ff;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
            transform: translateY(-2px);
          }

          &:active {
            background-color: #3a8ee6;
            color: #ffffff;
            border-color: #3a8ee6;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
            transform: translateY(1px);
          }
        }
      }
    }

    .blog-nav {
      max-width: 1200px;
      margin: 0 auto;
      height: 32px; /* 恢复原始高度 */
      display: flex;
      justify-content: flex-start; /* 设置为左对齐 */
      align-items: center; /* 恢复垂直居中 */
      border-top: 1px solid rgba(0, 0, 0, 0.05);
      padding-top: 0; /* 恢复原始内边距 */
      margin-top: -2px; /* 保持横线与副标题之间的减少间距 */
      position: relative; /* 添加相对定位 */
      
      /* 移除这个伪元素，它可能干扰定位 */
      &::after {
        display: none;
      }
      
      .nav-buttons {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: flex-start; /* 设置为左对齐 */
        width: auto; /* 改为auto，让按钮组根据内容自适应宽度 */
        
        .nav-button {
          min-width: 70px;
          text-align: center;
          margin-right: 0px; /* 设置为0，因为按钮已经有padding */
          margin-left: 0px !important; /* 覆盖Element UI的默认margin-left: 10px */
          border-radius: 4px;
          transition: all 0.3s;
          font-weight: 500;
          padding: 8px 0px;
          position: relative; /* 添加相对定位以支持三角形定位 */
          margin-bottom: 0; /* 确保按钮底部没有额外的margin */
          
          &.el-button--primary {
            background-color: #409EFF;
            color: white;
            border-color: #409EFF;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.2);
            
            &:hover {
              background-color: #66b1ff;
              border-color: #66b1ff;
              box-shadow: 0 2px 10px rgba(64, 158, 255, 0.3);
            }
          }
          
          &.el-button--text {
            color: #606266;
            
            &:hover {
              color: #409EFF;
              background-color: rgba(64, 158, 255, 0.1);
            }
          }
          
          &:last-child {
            margin-right: 0;
          }
          
          /* 添加选中按钮的三角形指示器，类似tooltips风格 */
          &.selected-nav-button {
            color: white !important; /* 强制文字为白色 */
            margin-bottom: 0;
            position: relative;
            
            &::after {
              content: '';
              position: absolute;
              bottom: -9px; /* 恢复原始位置 */
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 0;
              border-left: 6px solid transparent;
              border-right: 6px solid transparent;
              border-top: 8px solid var(--btn-bg-color, #409EFF); /* 使用CSS变量设置颜色 */
              z-index: 2; /* 确保三角形在最上层 */
            }
          }
          
          /* 移除不再需要的样式 */
          &.el-button--primary:not(.selected-nav-button)::after {
            display: none;
          }
        }
        
        .bg-settings-container {
          margin-left: 2px; /* 从5px减少到2px，保持少量间距 */
          display: flex;
          align-items: center;
        }
      }
    }
  }
  
  .blog-content {
    width: 1200px; // 明确宽度，确保 calc() 有正确的基准
    max-width: 1200px;
    margin: 125px auto 0; /* 顶部margin改为头部高度，确保内容不被头部遮挡 */
    display: flex;
    gap: 20px;
    position: relative;
    z-index: 1;
    height: calc(100vh - 125px); /* 恢复原来的高度计算，使内容区域延伸到页面底部 */
    overflow: hidden; /* 防止整体出现滚动条 */
    padding-bottom: 0; /* 移除底部内边距 */
    
    .article-cards {
      flex: 1; // 控制 column 方向的高度，填满父容器
      width: calc(100% - 270px) !important; // 控制 row 方向的宽度
      min-width: 0;
      display: flex;
      flex-direction: column;
      overflow-y: auto; /* 允许文章区域滚动 */
      padding-right: 0; /* 移除为滚动条预留的空间 */
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */
      overscroll-behavior: none !important; /* 禁止过度滚动 - 添加!important增强优先级 */
      -webkit-overscroll-behavior: none !important; /* Safari支持 */
      -ms-scroll-chaining: none !important; /* IE/Edge支持 */
      -webkit-overflow-scrolling: touch; /* 在iOS上使用原生滚动动量 */
      
      /* 隐藏滚动条但保持滚动功能 - Webkit浏览器 */
      &::-webkit-scrollbar {
        display: none;
      }
      
      // 修改暂无文章区域的样式
      .no-data-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
      }

      // 修改暂无数据区域的样式
      .no-data {
        min-height: 400px;
        border-radius: 8px; // 与文章卡片一致的圆角
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #909399;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1); // 与文章卡片一致的阴影
        width: 100%;
        overflow: hidden;
        transition: transform 0.3s, box-shadow 0.3s;
        
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
        }
        
        .no-data-content {
          text-align: center;
          width: 100%;
          padding: 40px 20px;
          box-sizing: border-box;
          
          i {
            font-size: 80px;
            margin-bottom: 20px;
            color: #dcdfe6;
          }
          
          .no-data-title {
            font-size: 20px;
            color: #606266;
            font-weight: 500;
            display: block;
          margin-bottom: 10px;
          }
        }
        
        .no-data-tips {
          margin-top: 10px;
          font-size: 14px;
          color: #909399;
          line-height: 1.5;
        }
      }
      
      .article-card-container {
        width: 100%;

        .waterfall {
          display: grid;
          grid-template-columns: repeat(3, minmax(280px, 1fr));
          grid-gap: 20px;

          @media screen and (max-width: 1200px) {
            grid-template-columns: repeat(2, 1fr);
          }

          @media screen and (max-width: 768px) {
            grid-template-columns: 1fr;
          }

          .article-card {
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
            transition: all 0.3s ease;
            cursor: pointer;
            position: relative;
            display: flex;
            flex-direction: column;
            height: 200px;
            border: 1px solid rgba(0, 0, 0, 0.03);
            /* 移除固定透明背景 */

            .article-type-decoration {
              position: absolute;
              top: -60px;
              right: -60px;
              width: 120px;
              height: 120px;
              background: rgba(0, 0, 0, 0.03);
              transform: rotate(45deg);
              z-index: 1;
              transition: all 0.3s ease;
            }

            &.article-card-blue .article-type-decoration {
              background: rgba(64, 158, 255, 0.08);
            }

            &.article-card-green .article-type-decoration {
              background: rgba(103, 194, 58, 0.08);
            }

            &.article-card-orange .article-type-decoration {
              background: rgba(230, 162, 60, 0.08);
            }

            &.article-card-red .article-type-decoration {
              background: rgba(245, 108, 108, 0.08);
            }

            &.article-card-purple .article-type-decoration {
              background: rgba(142, 68, 173, 0.08);
            }

            &.article-card-teal .article-type-decoration {
              background: rgba(22, 160, 133, 0.08);
            }

            &.article-card-brown .article-type-decoration {
              background: rgba(211, 84, 0, 0.08);
            }

            &.article-card-navy .article-type-decoration {
              background: rgba(41, 128, 185, 0.08);
            }

            &.article-card-emerald .article-type-decoration {
              background: rgba(39, 174, 96, 0.08);
            }

            &.article-card-crimson .article-type-decoration {
              background: rgba(192, 57, 43, 0.08);
            }

            &:hover .article-type-decoration {
              transform: rotate(45deg) scale(1.2);
            }

            .read-count-bubble {
              position: absolute;
              top: 12px;
              right: 8px;
              background: rgba(64, 158, 255, 0.5);
              color: white;
              padding: 5px 12px;
              border-radius: 20px;
              font-size: 12px;
              display: flex;
              align-items: center;
              gap: 4px;
              z-index: 5;
              transition: all 0.3s ease;
              backdrop-filter: blur(2px);
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

              i {
                font-size: 14px;
              }
            }

            /* 置顶+加密标签容器 */
            .top-badges {
              position: absolute;
              top: 15px;
              left: 8px;
              display: flex;
              align-items: center;
              gap: 6px;
              z-index: 5;
              pointer-events: none;
            }

            /* 置顶胶囊样式 */
            .top-pill {
              height: 25px;
              width: 25px;
              padding: 0;
              border-radius: 4px;
              background: #E8F3FF;
              color: #1f6feb;
              font-size: 12px;
              font-weight: 700;
              letter-spacing: 0.3px;
              box-shadow: 0 2px 6px rgba(64, 158, 255, 0.18);
              border: 1px solid rgba(64, 158, 255, 0.28);
              display: inline-flex;
              align-items: center;
              justify-content: center;

              i { font-size: 14px; font-weight: bold; }
            }

            /* 加密胶囊样式 */
            .encrypted-pill {
              height: 25px;
              width: 25px;
              padding: 0;
              border-radius: 4px;
              background: #E6E8EB;
              color: #606266;
              font-size: 12px;
              font-weight: 600;
              letter-spacing: 0.3px;
              box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
              border: 1px solid rgba(0, 0, 0, 0.08);
              display: inline-flex;
              align-items: center;
              justify-content: center;

              i { font-size: 14px; font-weight: bold; }
            }

            &:hover {
              transform: translateY(-6px);
              box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);

              .article-title {
                color: #409EFF;
              }

              .read-count-bubble {
                background: rgba(64, 158, 255, 0.8);
                transform: scale(1.05);
              }

              .read-more {
                color: #409EFF;

                i {
                  transform: translateX(4px);
                }
              }
            }

            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 3px;
              background: linear-gradient(90deg, #409EFF, #67C23A, #E6A23C, #F56C6C);
              transform: scaleX(0);
              transform-origin: left;
              transition: transform 0.3s ease;
              z-index: 3;
            }

            &:hover::before {
              transform: scaleX(1);
            }

            .article-cover {
              height: 50px; // 装饰性色条高度
              flex-shrink: 0;
              overflow: hidden;
              position: relative;
              border-radius: 12px 12px 0 0;

              // 装饰色条各类型颜色
              &.article-cover-blue { background: linear-gradient(135deg, rgba(64,158,255,0.15), rgba(64,158,255,0.05)); }
              &.article-cover-green { background: linear-gradient(135deg, rgba(103,194,58,0.15), rgba(103,194,58,0.05)); }
              &.article-cover-orange { background: linear-gradient(135deg, rgba(230,162,60,0.15), rgba(230,162,60,0.05)); }
              &.article-cover-red { background: linear-gradient(135deg, rgba(245,108,108,0.15), rgba(245,108,108,0.05)); }
              &.article-cover-purple { background: linear-gradient(135deg, rgba(142,68,173,0.15), rgba(142,68,173,0.05)); }
              &.article-cover-teal { background: linear-gradient(135deg, rgba(22,160,133,0.15), rgba(22,160,133,0.05)); }
              &.article-cover-brown { background: linear-gradient(135deg, rgba(211,84,0,0.15), rgba(211,84,0,0.05)); }
              &.article-cover-navy { background: linear-gradient(135deg, rgba(41,128,185,0.15), rgba(41,128,185,0.05)); }
              &.article-cover-emerald { background: linear-gradient(135deg, rgba(39,174,96,0.15), rgba(39,174,96,0.05)); }
              &.article-cover-crimson { background: linear-gradient(135deg, rgba(192,57,43,0.15), rgba(192,57,43,0.05)); }
              &.article-cover-default { background: linear-gradient(135deg, rgba(0,0,0,0.04), rgba(0,0,0,0.02)); }
            }

            .article-info {
              padding: 0 15px;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              flex: 1;
              position: relative;
              background: transparent;
              border-top: 1px solid rgba(0, 0, 0, 0.03);
              backdrop-filter: blur(5px);

              .article-content {
                flex: none;
                padding: 10px 0 0;

                .title-wrap {
                  height: 60px;
                  overflow: hidden;
                }

                .article-title {
                  font-size: 16px;
                  font-weight: 600;
                  color: #303133;
                  line-height: 30px;
                  margin: 0 0 10px 0;
                  word-break: break-word;
                  overflow-wrap: break-word;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  transition: color 0.3s ease;
                }

                .article-meta {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-top: 10px;
                  padding-left: 0;

                  .article-type {
                    border: none;
                    font-weight: 500;
                    letter-spacing: 0.5px;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    padding: 0 8px;
                    margin-left: 2px;
                  }

                  .article-stats {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    font-size: 12px;
                    color: #909399;

                    .article-views, .article-time {
                      display: flex;
                      align-items: center;

                      i {
                        margin-right: 4px;
                        font-size: 14px;
                      }
                    }

                    .stats-divider {
                      color: #DCDFE6;
                      font-size: 12px;
                      margin: 0 -5px;
                    }
                  }
                }
              }

              .article-divider {
                height: 1px;
                background: linear-gradient(to right, rgba(0,0,0,0.03), rgba(0,0,0,0.06), rgba(0,0,0,0.03));
                margin: 6px 0;
              }

              .article-footer {
                position: relative;
                padding: 0 0 4px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                &::before {
                  display: none;
                }

                .article-tags {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 6px;
                  min-height: 24px;
                  flex: 1;

                  .article-tag {
                    margin: 0;
                    transition: all 0.2s ease;
                    border-radius: 12px;
                    padding: 0 8px;
                    font-size: 11px;
                    background: rgba(0,0,0,0.03);
                    color: #606266;
                    border: none;

                    &:hover {
                      transform: scale(1.05);
                      background: rgba(64, 158, 255, 0.1);
                      color: #409EFF;
                    }
                  }
                }

                .article-tags-placeholder {
                  min-height: 24px;
                  flex: 1;
                }

                .read-more {
                  font-size: 12px;
                  color: #909399;
                  display: flex;
                  align-items: center;
                  gap: 4px;
                  transition: color 0.3s ease;

                  i {
                    transition: transform 0.3s ease;
                  }
                }
              }
            }
          }
        }
      }

      /* 列表视图样式 */
      .article-list-container {
        min-width: 0;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        overflow: visible; // 让内容自然溢出，由父容器.article-cards处理滚动
        scrollbar-width: none;
        -ms-overflow-style: none;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
          display: none;
        }

        .article-list-empty {
          width: 100%;
          min-height: 400px;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #909399;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
          box-sizing: border-box;

          .no-data-content {
            width: 100%;
            text-align: center;
            padding: 40px 20px;
            box-sizing: border-box;

            i {
              font-size: 80px;
              margin-bottom: 20px;
              color: #dcdfe6;
            }

            .no-data-title {
              font-size: 20px;
              color: #606266;
              font-weight: 500;
              display: block;
              margin-bottom: 10px;
            }

            .no-data-tips {
              margin-top: 10px;
              font-size: 14px;
              color: #909399;
              line-height: 1.5;
            }
          }
        }

        .article-list-item {
          display: flex;
          width: 100%;
          max-width: 100%; // 确保不超过容器
          box-sizing: border-box;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
          cursor: pointer;
          margin-bottom: 12px;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);

            .list-item-title {
              color: #409EFF;
            }

            .list-item-arrow {
              transform: translateX(4px);
            }
          }

          .list-item-type {
            width: 60px;
            min-height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            border-radius: 0;

            .type-text {
              color: white;
              font-size: 14px;
              font-weight: 600;
              writing-mode: vertical-lr;
              text-orientation: mixed;
              letter-spacing: 2px;

              &.is-english {
                writing-mode: horizontal-tb;
                text-orientation: mixed;
              }
            }
          }

          .list-item-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            padding: 4px 15px;
            min-height: 60px;
            min-width: 0;
            box-sizing: border-box;
            overflow: hidden;
            width: 100%; // 强制占满可用宽度

            .list-item-row1 {
              display: flex;
              align-items: center;
              height: 34px;
              min-width: 0;
              overflow: hidden;

              .list-item-title {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
                margin: 0;
                flex: 1;
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                transition: color 0.3s ease;
                line-height: 34px;
              }

              .list-item-views {
                display: flex;
                align-items: center;
                gap: 4px;
                color: #909399;
                font-size: 13px;
                flex-shrink: 0;
                margin-left: 15px;
                min-width: 50px;
                justify-content: flex-end;

                i {
                  font-size: 14px;
                }
              }
            }

            .list-item-row2 {
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 24px;
              padding-bottom: 4px;

              .list-item-left {
                display: flex;
                align-items: center;
                gap: 8px;
                flex: 1;
                overflow: hidden;

                .list-item-badge {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 22px;
                  height: 22px;
                  border-radius: 4px;
                  flex-shrink: 0;

                  i {
                    font-size: 12px;
                    font-weight: bold;
                  }

                  &.top-badge {
                    background: #E8F3FF;
                    color: #1f6feb;
                  }

                  &.lock-badge {
                    background: #E6E8EB;
                    color: #606266;
                  }
                }

                .list-item-tags {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 6px;
                  overflow: hidden;

                  .list-tag {
                    margin: 0;
                    padding: 0 8px;
                    height: 20px;
                    line-height: 18px;
                    font-size: 11px;
                    border-radius: 10px;
                    background: rgba(0, 0, 0, 0.03);
                    color: #606266;
                    border: none;
                  }
                }
              }

              .list-item-right {
                display: flex;
                align-items: center;
                flex-shrink: 0;
                margin-left: 10px;

                .list-item-date {
                  font-size: 12px;
                  color: #909399;
                }
              }
            }
          }
        }
      }

      .load-more, .loading-more, .no-more {
        text-align: center;
        margin-top: 10px;
        padding: 5px 0;
        
        .el-button {
          font-size: 14px;
        }
      }
      
      .loading-more {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;
        color: #909399;
        
        i {
          font-size: 16px;
        }
      }
      
      .no-more {
        text-align: center;
        
        span {
        color: #909399;
          font-size: 12px; /* 恢复原来的12px字体大小 */
        }
        
        /* 增强版权信息样式优先级 */
        .copyright-info {
          text-align: center !important;
          width: 100% !important;
          margin: 5px auto !important;
          display: block !important;
          
          .pc-copyright {
            text-align: center !important;
          }
          
          .mobile-copyright {
            text-align: center !important;
            width: 100% !important;
          }
        }
      }
    }
    
    .filter-panel {
      width: 250px;
      flex-shrink: 0;
      height: 100%; /* 确保高度占满容器 */
      overflow-y: auto; /* 允许过滤区域独立滚动 */
      padding-right: 0; /* 移除为滚动条预留的空间 */
      padding-bottom: 0; /* 移除底部内边距 */
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */
      overscroll-behavior: none !important; /* 禁止过度滚动 - 添加!important增强优先级 */
      -webkit-overscroll-behavior: none !important; /* Safari支持 */
      -ms-scroll-chaining: none !important; /* IE/Edge支持 */
      -webkit-overflow-scrolling: touch; /* 在iOS上使用原生滚动动量 */
      
      /* 隐藏滚动条但保持滚动功能 - Webkit浏览器 */
      &::-webkit-scrollbar {
        display: none;
      }
      
      .blogger-card, .filter-card {
        margin-bottom: 20px;
        border-radius: 8px !important; /* 强制覆盖 el-card 默认样式 */
        overflow: hidden;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1) !important; /* 强制覆盖 el-card 默认样式 */
        transition: transform 0.3s, box-shadow 0.3s;
        
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2) !important; /* 强制覆盖 el-card 默认样式 */
        }
        
        &:last-child {
          margin-bottom: 0;
        }
        
        /* 覆盖 el-card 的内部样式 */
        :deep(.el-card__body) {
          padding: 15px;
        }
      }
      
      .blogger-card {
        height: 280px; // 恢复原来的高度
        box-sizing: border-box;
        
        .blogger-info {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 15px 20px 25px;
          height: 100%;
          box-sizing: border-box;
          justify-content: center;
          
          .blogger-avatar {
            width: 90px; /* 从80px增加到90px，使头像更加突出 */
            height: 90px; /* 从80px增加到90px，使头像更加突出 */
            border-radius: 50%;
            overflow: hidden;
            margin-bottom: 16px; /* 从12px增加到16px，增加与名称之间的间距 */
            border: 2px solid #ebeef5;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          
          .blogger-details {
            text-align: center;
            width: 100%;
            
            .blogger-name {
              font-size: 18px;
              font-weight: 600;
              margin: 0 0 8px; /* 从4px增加到8px，增加与简介之间的间距 */
              color: #303133;
            }
            
            .blogger-bio {
              font-size: 14px;
              color: #606266;
              margin: 0 0 12px;
              line-height: 1.4;
            }
            
            .blogger-divider {
              width: 80%;
              height: 1px;
              background-color: rgba(0, 0, 0, 0.05);
              margin: 15px auto;
            }
            
            .blogger-stats {
              display: flex;
              justify-content: center;
              gap: 30px;
              margin-top: 5px; /* 从20px减少到5px，因为已经有分隔线和margin */
              width: 100%;
              margin-bottom: 0;
              
              .stats-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                min-width: 36px; /* 确保有足够的宽度容纳数字 */
                
                .stats-number {
                  font-size: 22px; /* 从28px减小到22px，为大数字节省空间 */
                  font-weight: bold;
                  color: #409EFF;
                  line-height: 1;
                  margin-bottom: 5px;
                  white-space: nowrap; /* 防止数字换行 */
                }
                
                .stats-label {
                  font-size: 12px;
                  color: #909399;
                  line-height: 1;
                }
              }
            }
          }
        }
      }
      
      .filter-card {
        .filter-header {
          border-bottom: 1px solid #ebeef5;
          padding-bottom: 10px;
          margin-bottom: 10px;
          
          .filter-title {
            font-size: 16px;
            font-weight: 600;
            color: #303133;
            position: relative;
            padding-left: 10px;
            display: flex;
            align-items: center;
            
            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 3px;
              height: 14px;
              background-color: #409eff;
              border-radius: 1px;
            }
          }
        }
        
        .filter-content {
          padding: 0 5px;
          .filter-types, .filter-tags {
            display: flex;
            flex-wrap: wrap;
            gap: 5px; /* 减小标签之间的间距 */
            margin-top: 10px;
            
            /* 修改标签样式，让标签默认为灰色，选中时为蓝色 */
            .filter-type-item, .filter-tag-item {
              cursor: pointer;
              margin: 0 0 5px; /* 减小底部边距 */
              padding: 0 10px;
              height: 22px;
              line-height: 20px;
              font-size: 12px;
              border-radius: 11px; /* 使标签更圆润 */
              transition: all 0.25s ease;
              background-color: rgba(240, 242, 245, 0.7);
              color: #606266; /* 默认文字颜色为灰色 */
              border-color: transparent;
              white-space: nowrap; /* 防止标签文本换行 */
              
              &.active, &.el-tag--dark {
                color: white;
                background-color: #409eff;
                border-color: transparent;
                box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
              }
              
              &:hover:not(.active):not(.el-tag--dark) {
                color: #409eff;
                background-color: rgba(64, 158, 255, 0.1);
                transform: translateY(-1px);
              }
            }
          }
          
          .filter-tags {
            max-height: 250px; /* 稍微减小高度 */
            overflow-y: auto !important;
            padding: 2px 0;
            scrollbar-width: none;
            -ms-overflow-style: none;
            position: relative;
            z-index: 10;
            overscroll-behavior: contain;
            -webkit-overflow-scrolling: touch;
            touch-action: pan-y;
            scroll-behavior: smooth;
            will-change: transform;
            display: flex; /* 使用弹性布局替代网格 */
            flex-wrap: wrap; /* 允许换行 */
            gap: 5px; /* 保持原有间距 */
            align-items: flex-start;
            
            /* 隐藏滚动条但保持滚动功能 */
            &::-webkit-scrollbar {
              display: none;
            }
            
            /* 防止触摸设备上的滚动失效 */
            @media (pointer: coarse) {
              overflow-y: scroll !important;
              -webkit-overflow-scrolling: touch;
            }
          }
          
          .search-tip {
            font-size: 12px;
            color: #909399;
            margin-top: 5px;
            text-align: right;
          }
          
          .tag-search-input {
            margin-bottom: 10px;
            
            :deep(.el-input__inner) {
              height: 30px;
              line-height: 30px;
              border-radius: 15px;
              padding-left: 30px;
              font-size: 12px;
            }
            
            :deep(.el-input__prefix) {
              left: 10px;
            }
          }
        }
      }
    }
  }
}

// 媒体查询-适配移动设备
@media screen and (max-width: 768px) {
  .blog-home {
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin: 0;
    overflow-x: hidden; // 防止水平滚动
    
    .blog-header {
      height: 80px;
      
      .blog-header-content {
        height: 70px;
        justify-content: space-between;
        padding: 0 15px;
        display: flex;
        align-items: center; /* 添加垂直居中对齐 */
        
        .blog-info {
          padding-left: 5px;
          display: flex; /* 设置为flex布局 */
          flex-direction: column; /* 垂直排列 */
          justify-content: center; /* 垂直居中 */
          height: 100%; /* 确保高度撑满父容器 */
          
          .blog-title {
            font-size: 22px;
            margin-bottom: 2px;
            
            .crown-icon {
              left: -22px;
              top: -12px;
              font-size: 26px;
            }
          }
          
          .blog-subtitle {
            font-size: 12px;
            text-align: left;
            margin-top: 2px;
          }
        }
      }
      
      .blog-nav {
        display: none;
      }
    }
    
    // 移动端分类过滤栏样式
    .mobile-type-filter {
      position: fixed;
      top: 80px;
      left: 0;
      right: 0;
      z-index: 9;
      height: 40px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      
      .mobile-type-filter-scroll {
        display: flex;
        overflow-x: auto;
        white-space: nowrap;
        padding: 0 15px;
        height: 100%;
        -webkit-overflow-scrolling: touch;
        
        &::-webkit-scrollbar {
          display: none;
        }
        
        .mobile-type-item {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 0 10px;
          height: 30px;
          margin: 5px 5px 5px 0;
          border-radius: 15px;
          font-size: 13px;
          background-color: rgba(0, 0, 0, 0.05);
          color: #606266;
          transition: all 0.3s;
          font-weight: 500;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          min-width: 40px;
          
          &:first-child {
            margin-left: 0;
          }
          
          &:last-child {
            margin-right: 10px;
          }
          
          &.active {
            color: white;
            background-color: #409EFF;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.2);
            transform: translateY(-1px);
          }
          
          &:active {
            transform: translateY(1px);
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
    
.blog-content {
      margin-top: 130px;
      display: flex; // 修复：需要是 flex 容器
      flex-direction: column;
      padding: 0;
      width: 100vw; // 使用视口宽度单位
      max-width: 100vw; // 使用视口宽度单位
      height: calc(100vh - 130px); // 确保有固定高度供 flex: 1 的子元素填充
      box-sizing: border-box;
      margin-left: 0;
      margin-right: 0;

      .article-cards {
        flex: 1 1 auto; // 填满父容器高度
        width: 100% !important; // 移动端占满，强制覆盖 PC 样式
        min-width: 0; // 允许收缩，防止内容撑开容器
        height: 100%; // 使用固定高度，让overflow生效
        padding: 0; // 移除可能的内边距
        margin: 0; // 移除可能的外边距
        box-sizing: border-box;
        max-width: 100%; // 移动端不受侧边栏约束
        overflow-y: auto; // 允许滚动
        
        .article-card-container {
          padding: 0 10px; // 将左右两侧的内边距都调整为10px
          box-sizing: border-box;
          width: 100%; // 确保容器宽度为100%
          margin: 0 auto; // 居中显示，消除右侧边缘
          
          .waterfall {
            grid-template-columns: 1fr;
            grid-gap: 15px;
            padding-right: 0; // 移除右侧额外内边距
            width: 100%;
            
            .article-card {
              height: auto; // 自适应高度
              min-height: 220px;

              .article-cover {
                height: 50px; // 装饰性色条高度（移动端）
              }

              .article-info {
                padding: 0 15px;

                .article-content {
                  flex: none;
                  padding: 10px 0;

                  .title-wrap {
                    height: 60px;
                    overflow: hidden;
                  }

                  .article-title {
                    font-size: 16px;
                    line-height: 30px;
                    margin: 0 0 10px 0;
                    word-break: break-all;
                    overflow-wrap: break-word;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                  }

                  .article-meta {
                    padding-left: 0;
                    margin-top: 10px;

                    .article-type {
                      margin-left: 0;
                    }
                  }
                }

                .article-divider {
                  margin: 6px 0;
                }

                .article-footer {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding: 0 0 4px;

                  .article-tags, .article-tags-placeholder {
                    min-height: 22px;
                    padding-left: 2px;
                    display: flex;
                    flex-wrap: wrap;
                    gap: 6px;

                    .article-tag {
                      margin: 0;
                      padding: 0 8px;
                    }
                  }

                  .read-more {
                    padding-right: 2px;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    font-size: 12px;
                  }
                }
              }
            }
          }
        }
        
        // 统一有无文章时的页面显示样式
        .no-data {
          min-height: 300px;
          
          .no-data-content {
            padding: 30px 15px;
            
            i {
              font-size: 60px;
              margin-bottom: 15px;
            }
            
            .no-data-title {
              font-size: 18px;
              margin-bottom: 8px;
            }
            
            .no-data-tips {
              font-size: 13px;
              padding: 0 10px;
            }
          }
        }

        // 移动端列表视图
        .article-list-container {
          min-width: 0;
          width: 100% !important;
          max-width: 100% !important;
          height: 100%; // 填满父容器高度
          padding: 0 10px;
          box-sizing: border-box;
          overflow-x: hidden;
          overflow-y: auto; // 列表自身滚动
          scrollbar-width: none;
          -ms-overflow-style: none;
          -webkit-overflow-scrolling: touch;

          &::-webkit-scrollbar {
            display: none;
          }

          .article-list-empty {
            width: 100%;
            min-height: 300px;
            box-sizing: border-box;

            .no-data-content {
              width: 100%;
              padding: 30px 15px;
              box-sizing: border-box;

              i {
                font-size: 60px;
                margin-bottom: 15px;
              }

              .no-data-title {
                font-size: 18px;
                margin-bottom: 8px;
              }

              .no-data-tips {
                font-size: 13px;
                padding: 0 10px;
              }
            }
          }

          .article-list-item {
            margin-bottom: 10px;
            border-radius: 6px;

            .list-item-type {
              width: 45px;
              min-height: 52px;

              .type-text {
                font-size: 12px;
              }
            }

            .list-item-content {
              padding: 4px 12px;
              min-height: 52px;
              min-width: 0;
              overflow: hidden;
              width: 100%; // 强制占满可用宽度
              box-sizing: border-box;

              .list-item-row1 {
                height: 28px;
                min-width: 0;
                overflow: hidden;

                .list-item-title {
                  font-size: 14px;
                  line-height: 28px;
                }

                .list-item-views {
                  font-size: 12px;
                  margin-left: 10px;
                  min-width: 40px;

                  i {
                    font-size: 13px;
                  }
                }
              }

              .list-item-row2 {
                height: 22px;
                padding-bottom: 2px;

                .list-item-left {
                  gap: 6px;

                  .list-item-badge {
                    width: 18px;
                    height: 18px;

                    i {
                      font-size: 10px;
                    }
                  }

                  .list-item-tags {
                    gap: 4px;

                    .list-tag {
                      padding: 0 6px;
                      height: 18px;
                      line-height: 16px;
                      font-size: 10px;
                    }
                  }
                }

                .list-item-right {
                  gap: 6px;
                  margin-left: 8px;

                  .list-item-date {
                    font-size: 11px;
                  }
                }
              }
            }
          }
        }
    }

    .filter-panel {
        display: none;
      }
    }
    
    /* 移动端按钮组的样式 */
    .mobile-action-buttons {
      position: fixed !important;
      right: 15px !important;
      bottom: 80px !important;
      display: flex !important;
      flex-direction: column !important;
      gap: 15px !important;
      z-index: 2001 !important;
      
      .mobile-icon-btn {
        width: 40px !important;
        height: 40px !important;
        border-radius: 40px !important;
        background-color: rgba(255, 255, 255, 0.7) !important;
        color: #409eff !important;
        border: none !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        padding: 0 !important;
        transition: all 0.3s ease !important;
        
        i {
          font-size: 20px !important;
        }
        
        &:hover, &:focus {
          background-color: rgba(255, 255, 255, 0.9) !important;
          transform: scale(1.05) !important;
        }
        
        &:active {
          background-color: rgba(255, 255, 255, 1) !important;
          transform: scale(0.95) !important;
        }
      }
    }
    
    /* 统一移动端按钮包装器样式 */
    .mobile-btn-wrapper {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      width: 40px !important;
      height: 40px !important;
    }

    /* 确保移动端背景设置按钮包装器正确显示 */
    .mobile-bg-settings-wrapper {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      width: 40px !important;
      height: 40px !important;
      z-index: 2001 !important;
    }
  }
  
  /* 移动端导航菜单相关样式保持不变 */
  .mobile-nav-menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 250px;
    height: 100vh;
    background: rgba(255, 255, 255, 0.95);
    z-index: 99;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    
    &.active {
      transform: translateX(0);
    }
    
    .mobile-nav-header {
      padding: 20px 15px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      
      .mobile-blogger-info {
        display: flex;
        align-items: center;
        
        .mobile-blogger-avatar {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 15px;
          border: 2px solid #ebeef5;
          
          img {
      width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        
        .mobile-blogger-details {
          .mobile-blogger-name {
            font-size: 16px;
            font-weight: 600;
            margin: 0;
            color: #303133;
          }
          
          .mobile-blogger-bio {
            font-size: 12px;
            color: #606266;
            margin: 5px 0 0;
          }
        }
      }
    }
    
    .mobile-nav-search {
      padding: 15px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }
    
    .mobile-nav-tags {
      padding: 15px;
      flex: 1;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      
      &::-webkit-scrollbar {
        display: none; // 隐藏滚动条
      }
      
      .mobile-nav-section-title {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 15px;
        position: relative;
        padding-left: 10px;
        
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 14px;
          background-color: #409eff;
          border-radius: 1px;
        }
      }
      
      .mobile-tag-list {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 20px;
        
        .mobile-tag-item {
          cursor: pointer;
          padding: 0 12px;
          height: 24px;
          line-height: 22px;
          font-size: 12px;
          border-radius: 12px;
          transition: all 0.25s ease;
          background-color: rgba(240, 242, 245, 0.7);
          color: #606266;
          border-color: transparent;
          margin: 0;
          
          &.active {
            color: white;
            background-color: #409eff;
            border-color: transparent;
            box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
          }
          
          &:hover:not(.active) {
            color: #409eff;
            background-color: rgba(64, 158, 255, 0.1);
            transform: translateY(-2px);
          }
        }
      }
    }
  }
  
  .mobile-nav-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 98;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    
    &.active {
      opacity: 1;
      visibility: visible;
    }
  }
  
  /* 暗色模式下移动端按钮样式 */
  .mobile-action-buttons .mobile-icon-btn {
    background-color: rgba(30, 30, 30, 0.5) !important;
    color: #67b3fd !important;
    
    &:hover, &:focus {
      background-color: rgba(40, 40, 40, 0.8) !important;
    }
    
    &:active {
      background-color: rgba(50, 50, 50, 0.9) !important;
    }
  }
}

// 确保PC版本显示正常
@media screen and (min-width: 769px) {
  .mobile-nav-menu,
  .mobile-nav-backdrop,
  .mobile-type-filter,
  .mobile-action-buttons {
    display: none;
  }
  
  .blog-content {
    .filter-panel {
      display: block;
    }
  }
}

// 添加no-data-tips样式
.no-data-tips {
  margin-top: 10px;
  font-size: 14px;
  color: #909399;
  text-align: center;
}

/* 添加版权信息样式 */
.copyright-info {
  text-align: center;
  padding: 5px 0;
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
  flex-shrink: 0;
  
  .pc-copyright {
    display: inline;
  }
  
  .mobile-copyright {
    display: none;
}
}

@media screen and (max-width: 768px) {
  .blog-home {
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin: 0;
    overflow-x: hidden; // 防止水平滚动
    
    // ... existing code ...
    
    /* 移动端版权信息样式 */
    .copyright-info {
      text-align: center !important;
      width: 100% !important;
      
      .pc-copyright {
        display: none;
      }
      
      .mobile-copyright {
        display: inline-block;
        text-align: center !important;
        width: 100% !important;
      }
    }
    
    // ... existing code ...
  }
  
  // ... existing code ...
}

// 修改强制覆盖样式，确保从其他页面返回后版权信息依然居中
.blog-home .article-cards .no-more .copyright-info {
  text-align: center !important;
  width: 100% !important;
  display: block !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

// PC版本正常显示，但移动版本在PC端应该隐藏
.blog-home .article-cards .no-more .copyright-info .pc-copyright {
  text-align: center !important;
  width: 100% !important;
  display: inline !important; /* 确保在PC端显示 */
}

// 在非移动端环境下确保移动版本隐藏
@media screen and (min-width: 769px) {
  .blog-home .article-cards .no-more .copyright-info .mobile-copyright {
    display: none !important; /* 强制在PC端隐藏 */
  }
}

// 只在移动端显示移动版本
@media screen and (max-width: 768px) {
  .blog-home .article-cards .no-more .copyright-info .pc-copyright {
    display: none !important; /* 强制在移动端隐藏 */
  }
  
  .blog-home .article-cards .no-more .copyright-info .mobile-copyright {
    text-align: center !important;
    width: 100% !important;
    display: inline-block !important; /* 只在移动端显示 */
  }
}

/* 背景设置对话框样式 */
:deep(.bg-settings-dialog) {
  /* 这部分样式将由BackgroundSettings组件提供 */
}

/* 自定义文章卡片的tooltip样式 */
:global(.article-card-container .el-tooltip__popper) {
  font-size: 16px !important;
  padding: 8px 12px !important;
}
</style> 

<!-- 添加全局样式 -->
<style>
.el-tooltip__popper.is-dark {
  font-size: 16px;
  padding: 8px 12px;
  line-height: 1.4;
}

/* 博客页面特定的全局样式，覆盖App.vue中的移动端样式 */
.blog-page-container .mobile-menu-btn {
  display: none !important; /* 强制隐藏App.vue中的移动端菜单按钮 */
}

.mobile-bg-settings-wrapper .bg-settings-btn {
  width: 40px !important;
  height: 40px !important;
  border-radius: 40px !important;
  background-color: rgba(255, 255, 255, 0.5) !important;
  color: #409eff !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 0 !important;
  position: static !important;
  top: auto !important;
  right: auto !important;
}

@media (prefers-color-scheme: dark) {
  .mobile-bg-settings-wrapper .bg-settings-btn {
    background-color: rgba(30, 30, 30, 0.7) !important;
    color: #67b3fd !important;
  }

  .mobile-bg-settings-wrapper .bg-settings-btn:hover,
  .mobile-bg-settings-wrapper .bg-settings-btn:focus {
    background-color: rgba(40, 40, 40, 0.9) !important;
  }

  .mobile-bg-settings-wrapper .bg-settings-btn:active {
    background-color: rgba(50, 50, 50, 1) !important;
  }
}

/* 加密文章遮罩样式（已移除） */</style> 
